<section class="test-container">
  <div class="header">
    <h1>External Precheck Test</h1>
    <p class="subtitle">Create a session to test the external precheck component</p>
  </div>

  <div class="card">
    <form [formGroup]="sessionForm" (ngSubmit)="createSession()" class="session-form">
      <div class="form-group">
        <label for="userId">User ID</label>
        <input
          type="text"
          id="userId"
          formControlName="userId"
          placeholder="Enter user identifier"
          [class.is-invalid]="sessionForm.get('userId')?.invalid && sessionForm.get('userId')?.touched"
        />
        <div *ngIf="sessionForm.get('userId')?.invalid && sessionForm.get('userId')?.touched" class="error-message">
          User ID is required
        </div>
      </div>

      <div class="form-group">
        <label for="marketplaceId">Marketplace ID</label>
        <input
          type="text"
          id="marketplaceId"
          formControlName="marketplaceId"
          placeholder="Enter marketplace identifier"
          [class.is-invalid]="sessionForm.get('marketplaceId')?.invalid && sessionForm.get('marketplaceId')?.touched"
        />
        <div *ngIf="sessionForm.get('marketplaceId')?.invalid && sessionForm.get('marketplaceId')?.touched" class="error-message">
          Marketplace ID is required
        </div>
      </div>

      <div class="form-actions">
        <button
          type="submit"
          class="btn-primary"
          [disabled]="sessionForm.invalid || isLoading"
        >
          <span *ngIf="!isLoading">Create Session</span>
          <span *ngIf="isLoading">Creating...</span>
        </button>
        <button
          *ngIf="sessionId"
          type="button"
          class="btn-secondary"
          (click)="clearSession()"
        >
          Clear Session
        </button>
      </div>
    </form>

    <div *ngIf="sessionId" class="session-display">
      <div class="session-info">
        <h3>Session Created</h3>
        <p class="session-status success">✓ Session is valid and active</p>

        <div class="session-container">
          <div class="session-header" (click)="toggleSessionDetails()" [class.expanded]="sessionDetailsExpanded">
            <span class="session-label">Session ID</span>
            <div class="session-actions">
              <button
                class="copy-btn"
                (click)="copySessionId($event)"
                title="Copy session ID to clipboard"
                aria-label="Copy session ID to clipboard">
                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                  <rect x="9" y="9" width="13" height="13" rx="2" ry="2"></rect>
                  <path d="M5 15H4a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h9a2 2 0 0 1 2 2v1"></path>
                </svg>
                <span>Copy</span>
              </button>
              <span class="toggle-icon">
                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                  <polyline *ngIf="!sessionDetailsExpanded" points="6 9 12 15 18 9"></polyline>
                  <polyline *ngIf="sessionDetailsExpanded" points="18 15 12 9 6 15"></polyline>
                </svg>
              </span>
            </div>
          </div>
          <div class="session-content" [class.expanded]="sessionDetailsExpanded">
            <div *ngIf="sessionDetails && sessionDetailsExpanded" class="session-details">
              <div class="session-detail" *ngIf="sessionDetails.submissionId">
                <span class="detail-label">Submission ID:</span>
                <span class="detail-value">{{ sessionDetails.submissionId }}</span>
              </div>
              <div class="session-detail">
                <span class="detail-label">User:</span>
                <span class="detail-value">{{ sessionDetails.user?.id }} ({{ sessionDetails.user?.email }})</span>
              </div>
              <div class="session-detail">
                <span class="detail-label">Valid:</span>
                <span class="detail-value">{{ sessionDetails.valid ? 'Yes' : 'No' }}</span>
              </div>
            </div>
            <div class="session-id-display">
              <pre>{{ sessionId }}</pre>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <!-- Iframe section - only displayed when session is available -->
  <ng-container *ngIf="iframeUrl">
    <div class="iframe-container">
      <h2>Precheck External Component Preview</h2>
      <div class="iframe-wrapper">
        <iframe [src]="iframeUrl" width="100%" height="800px"></iframe>
      </div>
    </div>
  </ng-container>

  <!-- Message when no session is available -->
  <div *ngIf="!iframeUrl" class="no-session-message">
    <p>The precheck component will appear here after creating a session.</p>
  </div>
</section>

<!-- Spinner component -->
<ngx-spinner
  bdColor="rgba(0, 0, 0, 0.8)"
  size="medium"
  color="#fff"
  type="ball-clip-rotate"
  [fullScreen]="true">
  <p style="color: white">Creating session...</p>
</ngx-spinner>
